import download from "downloadjs"
import React, { useEffect, useState } from "react"
import Loader from "react-loaders"
import { toast } from "react-toastify"
import { Modal } from "reactstrap"
import api from "services/api.service"
import { userService } from "services/user.service"
import colors from "utils/colors"

const ProjectArtifactsModal = ({
  isOpen,
  toggleModal,
  alternativeId,
  scenarioId,
  alternativeName,
}) => {
  const [isDownloading, setIsDownloading] = useState(false)

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen])

  const downloadDocument = promptType => {
    setIsDownloading(true)
    api.getAlternativeWordDocument(alternativeId, promptType).then(blob => {
      setIsDownloading(false)
      download(blob, `${alternativeName} - Risk Document.docx`)
    })
  }

  const generateRisks = async () => {
    setIsDownloading(true)
    await api.generateRiskTasks(alternativeId, scenarioId)
    toast.success("3 Risks were added to Risk Register.")
    setIsDownloading(false)
  }

  const generateProjectPpt = async () => {
    setIsDownloading(true)
    api.getPowerPointDocument(alternativeId).then(blob => {
      setIsDownloading(false)
      download(blob, `${alternativeName} - Project Overview.ppt`)
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      size="md"
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Project Artifacts
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="mb-3">
          <button
            className={`btn btn-primary`}
            onClick={() => downloadDocument("ProjectCharter")}
            disabled={isDownloading}
            style={{
              width: "150px",
            }}
          >
            Project Charter
          </button>
          <div>
            A formal document that authorizes a project, outlines its purpose,
            objectives, scope, stakeholders, and key deliverables, acting as a
            foundational document for project planning and execution.
          </div>
        </div>
        <div className="mb-3">
          <button
            className={`btn btn-primary`}
            onClick={() => downloadDocument("RiskDocument")}
            disabled={isDownloading}
            style={{
              width: "150px",
            }}
          >
            Risk Management
          </button>
          <div>
            A summary of key risks and potential mitigations identified from the
            currently provided project information.
          </div>
        </div>
        <div className="mb-3">
          <button
            className={`btn btn-primary`}
            onClick={() => downloadDocument("ProjectPlan")}
            disabled={isDownloading}
            style={{
              width: "150px",
            }}
          >
            Project Schedule
          </button>
          <div>
            A list of key tasks, including potential dates and durations in
            order to meet the provided project information and parameters.
          </div>
        </div>
        <div className="mb-3">
          <button
            className={`btn btn-primary`}
            onClick={generateRisks}
            disabled={isDownloading}
            style={{
              width: "150px",
            }}
          >
            Generate Risks
          </button>
          <div>
            This will evaluate the project and add the top 3 risks to the
            project risk register.
          </div>
        </div>
        <div className="mb-3">
          <button
            className={`btn btn-primary`}
            onClick={generateProjectPpt}
            disabled={isDownloading}
            style={{
              width: "250px",
            }}
          >
            Project Overview Presentation
          </button>
          <div>
            This will generate a PowerPoint outlining the project.
          </div>
        </div>
        {isDownloading && (
          <>
            <p style={{ textAlign: "center" }}>
              Generating document - this may take a minute
            </p>
            <Loader
              type="line-scale-pulse-out"
              color={colors.primary}
              style={{ textAlign: "center" }}
            />
          </>
        )}
      </div>

      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={toggleModal}
        >
          Close
        </button>
      </div>
    </Modal>
  )
}

export default ProjectArtifactsModal
